import React from 'react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { Icon } from '../ui/icon';
import { Z_INDEX } from './app-sidebar/constants';
import { getNewAdminUrl } from '../../utils/urls';

export const ORG_CONTEXT_BANNER_HEIGHT_PX = 44;

export function OrgContextBanner({ tenantId }: { tenantId: string }) {
  let switchOrgHref = '/superkudu/tenants';
  try {
    switchOrgHref = `${getNewAdminUrl()}/superkudu/tenants`;
  } catch {
    // Best-effort only (local/dev may not inject NEW_ADMIN_URL in some setups)
  }

  return (
    <div
      className="tw-fixed tw-left-0 tw-right-0 tw-top-0 tw-text-white"
      style={{
        height: `${ORG_CONTEXT_BANNER_HEIGHT_PX}px`,
        zIndex: Z_INDEX.SIDEBAR_MAIN + 1,
        backgroundColor: '#00af89',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        fontFamily:
          'Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
      }}
      role="status"
      aria-live="polite"
    >
      <div className="tw-relative tw-flex tw-h-full tw-items-center tw-justify-center tw-px-4">
        <div className="tw-min-w-0 tw-truncate tw-text-[0.775rem] tw-leading-5 tw-font-normal">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-whitespace-nowrap">
            <Icon
              icon={faTriangleExclamation}
              className="tw-h-4 tw-w-4 tw-shrink-0 tw-self-center tw--mt-px"
              style={{ color: 'orange', opacity: 0.95 }}
            />
            <span>
              You are impersonating <b>a user</b> on organization{' '}
              <b>{tenantId}</b>
            </span>
          </span>
        </div>

        <a
          href={switchOrgHref}
          className="tw-absolute tw-right-4 tw-text-[0.775rem] tw-leading-4 tw-font-bold tw-tracking-[0.02857em] tw-text-white tw-no-underline tw-uppercase tw-underline-offset-2 hover:tw-text-white hover:tw-underline"
        >
          Switch org
        </a>
      </div>
    </div>
  );
}
